import React, { useState } from 'react';
import { Card, Button, Table, Badge, Spinner, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { DUYET_HOIDONGDAODUC_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { trangThaiHDDDValue } from '@app/utils/define';
import { Get, Put } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';
import HoiDongDaoDucEdit from './HoiDongDaoDucEdit';
import HoiDongDaoDucAdd from './HoiDongDaoDucAdd';

const DuyetHoiDongDaoDuc = ({ hoSoId }) => {
    const [showModal, setShowModal] = useState(false);
    const [viewMode, setViewMode] = useState('list');
    const [modalMode, setModalMode] = useState('');
    const [dataEdit, setDataEdit] = useState(null);
    const [trangThai, setTrangThai] = useState('');
    const [ghiChu, setGhiChu] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const { isLoading, data: queryData, refetch } = useQuery(
        ['duyetHoiDongDaoDucData', hoSoId],
        () => Get(DUYET_HOIDONGDAODUC_API.GET_PAGING, null, { HoSoNghienCuuSinhId: hoSoId, PageIndex: 1, PageSize: 100 }),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        }
    }

    const handleAction = (item, mode) => {
        setDataEdit(item);
        setModalMode(mode);
        setTrangThai(mode);
        setGhiChu(item.ghiChuChinhSua || '');
        setShowModal(true);
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    const submitDuyet = async () => {
        if (!trangThai) {
            toast.warning('Vui lòng chọn trạng thái duyệt!');
            return;
        }

        const payload = {
            HoSoNghienCuuSinhId: hoSoId,
            SoQuyetDinh: dataEdit.soQuyetDinh || '',
            NgayCap: dataEdit.ngayCap || null,
            DonViCap: dataEdit.donViCap || '',
            FileHDDD: dataEdit.fileHDDD || '',
            TrangThai: trangThai,
            GhiChuChinhSua: ghiChu
        };

        setIsSaving(true);
        try {
            const res = await Put(DUYET_HOIDONGDAODUC_API.DUYET_HO_SO, dataEdit.id, payload);
            if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id || res.success)) {
                toast.success('Lưu thành công!');
                refetch();
                setShowModal(false);
            } else {
                toast.error(res?.message || 'Có lỗi xảy ra');
            }
        } catch (error) {
            toast.error(error?.message || 'Có lỗi xảy ra');
        } finally {
            setIsSaving(false);
        }
    };

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiHDDDValue.choDuyet: return <Badge variant="warning">Chờ duyệt</Badge>;
            case trangThaiHDDDValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            case trangThaiHDDDValue.tuChoi: return <Badge variant="danger">Từ chối</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    return (
        <>
        <Card className="h-100">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Hội đồng đạo đức</h5>
                    <Button variant="success" size="sm" onClick={() => setViewMode('add')}>
                        <i className="fas fa-plus mr-1"></i> HLĐT Thêm mới
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="text-center" width="50">STT</th>
                                    <th>Số quyết định</th>
                                    <th className="text-center">Ngày cấp</th>
                                    <th>Đơn vị cấp</th>
                                    <th className="text-center">File đính kèm</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th>Ghi chú</th>
                                    <th className="text-center" width="120">Thao tác</th>
                                </tr>
                            </thead>
                        <tbody>
                            {dataList.length > 0 ? (
                                dataList.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="text-center">{index + 1}</td>
                                        <td>{item.soQuyetDinh}</td>
                                        <td className="text-center">
                                            {item.ngayCap ? moment(item.ngayCap).format('DD/MM/YYYY') : ''}
                                        </td>
                                        <td>{item.donViCap}</td>
                                        <td className="text-center">
                                            {item.fileHDDD ? (
                                                (() => {
                                                    const path = item.fileHDDD;
                                                    const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                    const safePath = path.startsWith('/') ? path : `/${path}`;
                                                    const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                    let name = path.split('/').pop() || 'File';
                                                    name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                    return (
                                                        <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                            <i className="fas fa-paperclip mr-1"></i> {name}
                                                        </a>
                                                    );
                                                })()
                                            ) : (
                                                <span className="text-muted">Không có</span>
                                            )}
                                        </td>
                                        <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                        <td>{item.ghiChuChinhSua || ''}</td>
                                        <td className="text-center">
                                            {(() => {
                                                const status = item.trangThai;
                                                const isHoanThanh = status === trangThaiHDDDValue.hoanThanh;
                                                const isTuChoi = status === trangThaiHDDDValue.tuChoi;
                                                
                                                return (
                                                    <div className="d-flex justify-content-center text-nowrap">
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Duyệt')}>
                                                            <Button variant={isHoanThanh ? "success" : "outline-success"} size="sm" onClick={() => handleAction(item, trangThaiHDDDValue.hoanThanh)} className="mr-1">
                                                                <i className="fas fa-check"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Từ chối')}>
                                                            <Button variant={isTuChoi ? "danger" : "outline-danger"} size="sm" onClick={() => handleAction(item, trangThaiHDDDValue.tuChoi)} className="mr-1">
                                                                <i className="fas fa-times"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Sửa dành cho HLĐT')}>
                                                            <Button variant="info" size="sm" onClick={() => { setDataEdit(item); setViewMode('edit'); }}>
                                                                <i className="fas fa-edit"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                );
                                            })()}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center text-muted">
                                        Chưa có dữ liệu Hội đồng đạo đức
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    </div>
                )}
            </Card.Body>
        </Card>

        {showModal && (
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false} size="md">
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title>
                        {modalMode === trangThaiHDDDValue.hoanThanh ? 'Duyệt Hội đồng đạo đức' : 'Từ chối duyệt'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Ghi chú {modalMode === trangThaiHDDDValue.tuChoi && <span className="text-danger">*</span>}</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                placeholder={modalMode === trangThaiHDDDValue.tuChoi ? "Nhập lý do từ chối..." : "Nhập ghi chú (nếu có)..."} 
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isSaving}>
                        <i className="fas fa-times mr-1"></i> Hủy
                    </Button>
                    <Button variant="primary" onClick={submitDuyet} disabled={isSaving || (modalMode === trangThaiHDDDValue.tuChoi && !ghiChu.trim())}>
                        {isSaving ? 'Đang lưu...' : <><i className="fas fa-save mr-1"></i> Lưu lại</>}
                    </Button>
                </Modal.Footer>
            </Modal>
        )}
        
        {viewMode === 'edit' && dataEdit && (
            <HoiDongDaoDucEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} />
        )}
        {viewMode === 'add' && (
            <HoiDongDaoDucAdd hoSoId={hoSoId} setViewMode={setViewMode} refreshList={refetch} />
        )}
        </>
    );
};

export default DuyetHoiDongDaoDuc;
